export default __webpack_public_path__ + "static/startup-ip-valuation-664e54a38ecfd2a52016e998e4f70903.png";